import React from 'react';
import styles from './DropOffSchedule.module.scss';
import { Container, Row, Col, Input, Label, Form, FormGroup, Button } from 'reactstrap';
import FilterInTable from '../../../../views/Manage/FilterInTable';
import DataTable from 'react-data-table-component';

const data = [
    {
        id: 1,
        date: '20/06/2024',
        time: '10:00 am',
        warehouse: 'Warehouse A, Islamabad',
    },
    {
        id: 2,
        date: '20/06/2024',
        time: '10:00 am',
        warehouse: 'Warehouse A, Islamabad',
    },
    {
        id: 3,
        date: '20/06/2024',
        time: '10:00 am',
        warehouse: 'Warehouse A, Islamabad',
    },
    {
        id: 4,
        date: '20/06/2024',
        time: '10:00 am',
        warehouse: 'Warehouse A, Islamabad',
    },
];

const columns = [
    {
        name: 'Date',
        selector: (row) => row.date,
        sortable: true,
    },
    {
        name: 'Time',
        selector: (row) => row.time,
        sortable: true,
    },
    {
        name: 'Warehouse',
        selector: (row) => row.warehouse,
        sortable: true,
        grow: 2,
    },
    {
        name: 'Action',
        cell: (row) => (
            <div className={styles.actionBtns}>
                <Button color="light" type="button" className={styles.rescheduleButton}>Reschedule</Button>
                <Button color="link" type="button" className={styles.cancelButton}>Cancel</Button>
            </div>
        ),
        sortable: true,
    },
];

const customStyles = {
    headRow: {
        style: {
            backgroundColor: '#F2F2F2',
            color: '#1A2425',
            fontSize: '16px',
            fontWeight: '600',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "40px",
            paddingRight: "40px",
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '12px 40px',
        },
    },
};

const DropOffSchedule = () => {
    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Drop off Scheduler</h4>
            <Container fluid className={styles.scheduleContainer}>
                <Row className={styles.scheduleRow}>
                    <Form className={styles.formSection}>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col xs='12' lg={2}>
                                    <Label for="warehouse">Select Warehouse:</Label>
                                </Col>
                                <Col xs='12' lg={5}>
                                    <Input type="select" id="warehouse">
                                        <option>Choose from dropdown menu</option>
                                        <option>Choose from dropdown menu</option>
                                        <option>Choose from dropdown menu</option>
                                    </Input>
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col xs='12' lg={2}>
                                    <Label for="date">Select Date:</Label>
                                </Col>
                                <Col xs='12' lg={5}>
                                    <Input type="date" id="date" placeholder="Select date from date picker" />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row className={styles.formGroupRow}>
                                <Col xs='12' lg={2}>
                                    <Label for="time">Select Time:</Label>
                                </Col>
                                <Col xs='12' lg={5}>
                                    <Input type="select" id="time">
                                        <option>Choose from dropdown menu</option>
                                        <option>Choose from dropdown menu</option>
                                        <option>Choose from dropdown menu</option>
                                    </Input>
                                </Col>
                            </Row>
                        </FormGroup>

                        <Label for="shipmentDetails">Shipment Details:</Label>
                        <div className={styles.shipmentDetailFields}>
                            <FormGroup>
                                <Row className={styles.formGroupRow}>
                                    <Col xs='12' lg={2}>
                                        <Label for="packages">Number of Packages:</Label>
                                    </Col>
                                    <Col xs='12' lg={5}>
                                        <Input type="text" id="packages" placeholder="Add minimum order quantity" />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row className={styles.formGroupRow}>
                                    <Col xs='12' lg={2}>
                                        <Label for="goods">Type of Goods:</Label>
                                    </Col>
                                    <Col xs='12' lg={5}>
                                        <Input type="text" id="goods" placeholder="Add minimum order quantity" />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </div>
                    </Form>
                </Row>
            </Container>

            <h4 className={styles.sectionHeading}>Upcoming Drop offs</h4>
            <Container fluid className={styles.scheduleContainer}>
                <Row className={styles.scheduleRow}>
                    <FilterInTable componentName={"Dropoffs"} />
                    <div className={styles.table}>
                        <DataTable
                            columns={columns}
                            data={data}
                            pagination
                            highlightOnHover
                            customStyles={customStyles}
                        />
                    </div>
                </Row>
            </Container>
        </div>
    )
}

export default DropOffSchedule;